import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import CustomButton from "../../../components/CustomButton";
import CustomModal from "../../../components/CustomModal/CustomModal";
import CustomTextField from "../../../components/CustomTextField";
import {
  createVitalsByAppointmentIdWoLoader,
  getVitalsByAppointmentIdWoLoader,
} from "../../../redux/reducers/clinicSlice";
import { updateWeightByPetAndApntId } from "../../../redux/reducers/petSlice";

const getCoreVitalId = (vitals = []) => {
  if (!Array.isArray(vitals) || vitals.length === 0) return null;

  const coreVitals = vitals.filter(
    (vit) =>
      vit?.vitalGroupId === 1 ||
      vit?.vitalGroup?.toLowerCase?.() === "core vitals",
  );
  if (coreVitals.length === 0) return null;

  const withBodyWeight = coreVitals.filter((vit) =>
    vit?.data?.some?.(
      (entry) =>
        entry?.["Body Weight"] !== undefined &&
        entry?.["Body Weight"] !== null &&
        entry?.["Body Weight"] !== "",
    ),
  );

  const targetVitals = withBodyWeight.length > 0 ? withBodyWeight : coreVitals;

  return (
    [...targetVitals].sort((a, b) => (b?.vitalId ?? 0) - (a?.vitalId ?? 0))[0]
      ?.vitalId ?? null
  );
};

const UpdatePetWeight = ({ modVsble, details = {}, onCloseMod = () => {} }) => {
  const dispatch = useDispatch();
  const [petValues, setPetValues] = useState({ weight: "", weightErr: "" });

  useEffect(() => {
    if (details?.weight?.length > 0) {
      setPetValues({ ...petValues, weight: details?.weight });
    }
  }, [details]);

  const onChange = (name, value) => {
    const reqObj = {
      ...petValues,
      [name]: value,
      weightErr: value?.length > 0 ? "" : "This field is required",
    };
    setPetValues(reqObj);
  };

  const onUpdateWeight = () => {
    if (petValues?.weight?.length === 0 || !petValues?.weight) {
      return setPetValues({
        ...petValues,
        weightErr: "This field is required",
      });
    }
    dispatch(
      updateWeightByPetAndApntId({
        url: `/${details?.appointmentId}/pet/${details?.petId}/weight?weight=${petValues?.weight}`,
      }),
    ).then(async (res) => {
      if (res?.payload) {
        onCloseMod("apiSuccess");
        const data = {
          vitalGroupId: 1,
          vitalGroup: "Core Vitals",
          data: [{ "Body Weight": petValues?.weight }],
        };
        const vitRes = await dispatch(
          getVitalsByAppointmentIdWoLoader(details?.appointmentId),
        );
        const vitalId = getCoreVitalId(vitRes?.payload ?? []);
        if (vitalId) data.vitalId = vitalId;
        dispatch(
          createVitalsByAppointmentIdWoLoader({
            apntId: details?.appointmentId,
            data,
          }),
        );
      }
    });
  };

  return (
    <CustomModal
      open={modVsble}
      onClose={() => onCloseMod("close")}
      header="Update Weight"
      modal
      modalWidth={30}
      headerBold
    >
      <div className="ph20">
        <CustomTextField
          name="weight"
          value={petValues?.weight}
          fullWidth
          handleChange={(e) => onChange("weight", e?.target?.value)}
          label="Weight"
          error={!!petValues.weightErr}
          helperText={petValues.weightErr}
          type="number"
          suffix={petValues?.weight !== "" ? "Kg" : ""}
        />
        <div className="flex1-end mv20">
          <div>
            <CustomButton text="Update" smallBtn onClick={onUpdateWeight} />
          </div>
        </div>
      </div>
    </CustomModal>
  );
};

export default UpdatePetWeight;
